export { default } from './isImmutableOrderedMap'
